import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MenuComponent } from "./menu.component";
import { MenuItemDirective } from "./menu-item.directive";

@NgModule({
  declarations: [MenuComponent, MenuItemDirective],
  imports: [CommonModule],
  exports: [MenuComponent, MenuItemDirective],
})
export class MenuModule {}
